import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findCourseClassif({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/getCourseClassify`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCourseList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/getCourseList`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	save({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/updateCourseClassify`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delete({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/deleteCourseClassify`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/getCourseClassifyDetail`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getUploadUrl({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/getUploadUrl`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	updateCourse({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/updateCourse`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	deleteCourse({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/deleteCourse`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCourseDetail({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/getCourseDetail`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	// 反馈列表
	feedbackList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseFeedBack/findList`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 笔记列表
	studyNotesList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseStudyNote/findList`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getPlayerToken({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/getPlayerToken`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	findRole({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`role/findRole`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getChapterList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/getChapterList`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	//  新建课程、编辑课程
	updateChapter({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/updateChapter`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	//  获取章节详情
	getChapterDetail({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/getChapterDetail`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	//  删除章节
	deleteChapter({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`courseClassify/deleteChapter`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	//  获取考试任务列表
	listRxaminationPlan({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/plan/listByCourseId`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	//  课程上下架
	putawayCourse({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/courseClassify/putawayCourse`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
}
